import { AxiosPromise } from 'axios';
import apiClient from 'configs/axios';

export type BrandTrialRequest = {
  brandName: string;
  brandDomain: string;
  email: string;
};

export type BrandTrialResponse = {
  ok: boolean;
  email: string;
  brandName: string;
  brandDomain: string;
  userID: number;
  organizationID: number;
  accountStatus: 'created' | 'existing';
};

export type BrandTrialClaimResponse = {
  ok: boolean;
  projectId: number;
  workspaceId: number | null;
  alreadyProvisioned?: boolean;
};

export function createBrandTrial(
  data: BrandTrialRequest,
): AxiosPromise<BrandTrialResponse> {
  return apiClient.post('/ai-audit/public/trial', data);
}

export function claimBrandTrial(): AxiosPromise<BrandTrialClaimResponse> {
  return apiClient.post('/ai-audit/trials/claim');
}
